import {
  PERMISSION_GROUPS,
  ADMIN_ROOT_URL,
  USER_ROOT_URL,
} from '@/constants/constants'
import { PermissionGroup } from '@/types/common/index.d'
import { Users } from '@api/models'

/**
 * @deprecated ロール(Users - Group)ベースによる判定に移行します。
 */
export const hasViewPermissionDeprecated = (
  user: Users,
  portrichOnly: boolean,
  role: 'admin' | 'user',
) => {
  if (portrichOnly) {
    return user.is_portrich
  }
  if (role === 'admin') {
    return user.is_portrich || user.is_portrich_partner || user.is_forwarder
  }
  if (role === 'user') {
    return user.is_user || user.is_guest
  }
  return false
}

/**
 * ユーザーが指定された権限グループを持っているかどうかを確認する関数。
 *
 * @param user
 * @param requiredGroups
 * @returns
 */
export const hasViewPermission = (
  user: Users,
  requiredGroups: PermissionGroup[],
) => {
  if (!user.groups || !user.groups.length) return false
  if (!requiredGroups || requiredGroups.length === 0) return true

  return user.groups.some((group) =>
    requiredGroups.some((requiredGroup) => requiredGroup === group.name),
  )
}

/**
 * ユーザーの権限に基づいて適切なページにリダイレクトする関数。
 * フォワーダーは管理者ページに、ユーザー権限はユーザーダッシュボードにリダイレクトします。
 *
 * @param user
 * @returns リダイレクト先のURL
 */
export const redirectToAllowedPage = (user: Users): string => {
  if (
    user.groups.some((group) =>
      [PERMISSION_GROUPS.FORWARDER].some(
        (expectedGroup) => expectedGroup === group.name,
      ),
    )
  ) {
    return ADMIN_ROOT_URL
  }

  if (
    user.groups.some((group) =>
      [PERMISSION_GROUPS.CUSTOMER, PERMISSION_GROUPS.GUEST].some(
        (expectedGroup) => expectedGroup === group.name,
      ),
    )
  ) {
    return USER_ROOT_URL
  }

  // その他の権限はダッシュボードへ
  return '/user/dashboard'
}
